import { PspContext } from "@/config/contexts";
import { ChangeEvent, useContext, useId } from "react";

type UsePspSelectParams<T extends string | number | boolean | undefined> = {
  value: T;
  onChange: (value: T) => void;
};

export function usePspSelect<T extends string | number | boolean | undefined>({
  onChange,
  value,
}: UsePspSelectParams<T>) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  // -----------------------------------------------------------------------------
  // IDS
  // -----------------------------------------------------------------------------
  const selectId = useId();

  // -----------------------------------------------------------------------------
  // EVENT HANDLERS
  // -----------------------------------------------------------------------------
  function onChangeWrapper(event: ChangeEvent<HTMLSelectElement>) {
    const raw = event.target.value;
    const casted = typeof value === "number" ? (Number(raw) as T) : (raw as T);
    onChange(casted);
  }

  return { lang, onChangeWrapper, selectId };
}
